<template xmlns="http://www.w3.org/1999/html">
  <div>

    <!--开始扫二维码和输入二维码页面-->
    <div v-if="!showCheckCode" id="background"
      style="width: 100vw;
    position:fixed;
    background: url(/static/images/quax/scan_newbg.png) no-repeat;
    background-attachment:fixed;
    background-size:cover;
    height: 100vh;
    overflow: hidden;top: 0; left: 0; right: 0; bottom: 0;display: flex;flex-direction: column;overflow-y: auto;align-items: center;">

      <img src="/static/images/quax/logo.png" alt="" style="width: 35vw;height: auto;position: absolute;top:3vh" />
      <!-- <img src="/static/images/quax/baby.png" alt=""
        style="width: 100vw;height: auto;position: absolute;margin-top: -6vh;" /> -->
      <img src="/static/images/quax/xuanchuan.png" alt="" style="width: 35vw;;position: absolute;bottom:4vh" />

      <div class="card2">
        <div style="font-size: 12px;z-index: 1;color: black;">①点击扫描二维码查询</div>
        <img src="/static/images/quax/scan.png" alt="" style="z-index: 1;;width: 28vw;height: auto;margin-top: 0.5vh;"
          @click="toScan" />
        <div style="font-size: 12px;z-index: 1;color: black">②或手动输入防伪数码</div>

        <input type="text" v-model="antiCode"
          style="font-size: 13px;z-index: 1;width: 75%;height: 35px;border-radius: 30px;border: 1px solid rgb(132, 132, 132);padding-left: 5%;"
          placeholder="请输入16位防伪码进行查询" @input="handleInput" />
        <div
          style="z-index: 1;margin-top: 0.5vh;text-align: center;display: flex;flex-direction: column;align-items: center;"
          @click="queryAnti">
          <img src="/static/images/quax/query.png" alt="" style="z-index: 1;width: 75%;height: 35px;" />
          <span style="z-index: 2;margin-top: -28px;color: white;">查&nbsp;询</span>
        </div>

      </div>

    </div>
    <!--结束扫二维码和输入二维码页面-->



    <!--开始输入验证码页面-->
    <div v-if="showCheckCode" id="background"
      style="width: 100vw;
    position:fixed;
    background: url(/static/images/quax/scan_newbg2.png) no-repeat;
    background-attachment:fixed;
    background-size:cover;
    height: 100vh;
    overflow: hidden;top: 0; left: 0; right: 0; bottom: 0;display: flex;flex-direction: column;overflow-y: auto;align-items: center;">

      <!-- <img src="/static/images/quax/baby2.png" alt=""
        style="width: 100vw;height: auto;position: absolute;margin-top: -8vh;" /> -->
        <img src="/static/images/quax/logo.png" alt="" style="width: 35vw;height: auto;position: absolute;top:3vh" />
      <img src="/static/images/quax/xuanchuan.png" alt="" style="width: 35vw;;position: absolute;bottom:4vh" />

      <div class="card">
        <img src="/static/images/quax/antiinfo.png" alt=""
          style="z-index: 1;;width: 20vw;height: auto;margin-top: 0.5vh;" />
        <div style="font-size: 12px;z-index: 1;color: black;width: 90%;text-align: center;">您查询的防伪码为：{{ antiCode }}
          <br />您还需输入产品袋内6位校验码，查询产品真伪
        </div>

        <input type="number" v-model="checkCode"
          style="font-size: 13px;z-index: 1;width: 75%;height: 35px;border-radius: 30px;border: 1px solid rgb(132, 132, 132);padding-left: 5%;"
          placeholder="请输入产品袋内6位验证码" />
        <div
          style="z-index: 1;margin-top: 0.5vh;text-align: center;display: flex;flex-direction: column;align-items: center;"
          @click="queryCheckCode">
          <img src="/static/images/quax/query.png" alt="" style="z-index: 1;width: 75%;height: 35px;" />
          <span style="z-index: 2;margin-top: -28px;color: white;font-size: 14px;">确认并查询</span>
        </div>
        <!-- <img src="/static/images/quax/vediotip.png" alt=""
          style="z-index: 1;;width: 57vw;height: auto;margin-top: 0.5vh;" />
        <video preload="auto" controls webkit-playsinline="true" poster="/static/images/quax/baby2.png"
          x-webkit-airplay="true" playsinline="true" x5-video-player-type="h5" x5-video-orientation="h5"
          x5-video-player-fullscreen="true" style="object-fit:fill;z-index: 3;width: 57vw;height: 18vh;">
          <source src="/static/images/quax/info.mp4" type="video/mp4">
          </source>
        </video> -->

      </div>


    </div>
    <!--结束输入验证码页面-->


  </div>



</template>

<style scoped>
.card {
  position: absolute;
  height: 63vh;
  width: 80vw;
  bottom: 10vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
}

.card2 {
  position: absolute;
  height: 51vh;
  width: 80vw;
  bottom: 10vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
}

.card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(to bottom, rgb(240, 217, 231), rgb(191, 224, 242));
  box-shadow: 0px 0px 15px 0px rgb(232, 208, 238);
  border-radius: 35px;
}

.card::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(to bottom, rgb(240, 217, 231), rgb(191, 224, 242));
  filter: blur(60px);
  border-radius: 35px;
  box-shadow: 0px 0px 15px 0px rgb(232, 208, 238);
}

.card2::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(to bottom, rgba(231, 206, 237, 0.7), rgba(185, 222, 230, 0.6));
  box-shadow: 0px 0px 15px 0px rgba(232, 208, 238, 0.7);
  border-radius: 35px;
}

.card2::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(to bottom, rgba(228, 210, 233, 0.7), rgba(185, 222, 230, 0.7));
  filter: blur(60px);
  border-radius: 35px;
  box-shadow: 0px 0px 15px 0px rgba(232, 208, 238, 0.7);
}
</style>


<script>
import { getJSSDK, getWechatAuth } from '../../api/api'
import wx from 'weixin-js-sdk'
export default {
  data() {
    return {
      antiCode: "",
      showCheckCode: false,
      checkCode: "",
      wechatAuth: false,
      authCode: "",
      eno: ""
    }
  },
  methods: {
    handleInput() {
      this.antiCode = this.antiCode.replace(/(\w{4})(?=\w)/g, '$1 ');
    },
    getAuth() {
      if (this.authCode != null && this.authCode != "") {
        this.antiCode = this.antiCode.replace(/\s+/g, '')
        window.location.href = "/quax/activity?q=" + this.antiCode + "&c=" + this.checkCode + "&eno=" + this.eno + "&authCode=" + this.authCode
      } else {
        var url = window.location.href.split('#')[0];
        sessionStorage.setItem("wechatAuth", true);
        getWechatAuth(url, "wx48bec35c126c6e01", 1).then(res => {
          const data = res.data;
          window.location.href = data;
        }).catch(err =>
          alert("获取微信授权失败" + err)
        )
      }
    },
    toScan() {
      const params = this.$route.query;
      const eno = params.eno;
      if (eno == null || eno == undefined) {
        alert("请使用正确入口地址进行查询")
        return;
      }
      wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
        success: res => {
          var scanResult = res.resultStr
          var scanQRCode = scanResult
          if (scanResult.startsWith('http')) {
            let parts = scanResult.split('/');
            scanQRCode = parts.length > 0 ? parts[parts.length - 1] : ''
            scanQRCode = scanQRCode.substring(0, 16)
          }
          this.antiCode = scanQRCode.replace(/(\w{4})(?=\w)/g, '$1 ')
          this.queryAnti()
        }
      });
    },
    queryCheckCode() {
      if (this.checkCode == "" || this.checkCode.length != 6) {
        alert("请输入6位校验码进行查询验证")
        return;
      }
      sessionStorage.setItem("queryCode", this.antiCode.replace(/\s+/g, '') + "," + this.checkCode)
      this.getAuth()
    },
    queryAnti() {
      const params = this.$route.query;
      const eno = params.eno;
      if (eno == null || eno == undefined) {
        alert("请使用正确入口地址进行查询")
        return;
      }
      const code = this.antiCode.replace(/\s+/g, '');
      if (code == "" || code.length != 16) {
        alert("请输入16位防伪码进行查询验证")
        return;
      }
      this.showCheckCode = true
    },
    getWxJs() {
      const url = encodeURIComponent(window.location.href.split('#')[0])
      getJSSDK(url, "wx48bec35c126c6e01").then(res => {
        console.log(res)
        const data = res.data.data
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: data.appId, // 必填，公众号的唯一标识
          timestamp: data.timestamp, // 必填，生成签名的时间戳
          nonceStr: data.nonceStr, // 必填，生成签名的随机串
          signature: data.signature,// 必填，签名，见附录1
          openTagList: ["wx-open-launch-weapp", "wx-open-launch-app"],
          jsApiList: [
            'checkJsApi',
            'onMenuShareTimeline',
            'onMenuShareAppMessage',
            'onMenuShareQQ',
            'onMenuShareWeibo',
            'onMenuShareQZone',
            'hideMenuItems',
            'showMenuItems',
            'hideAllNonBaseMenuItem',
            'showAllNonBaseMenuItem',
            'translateVoice',
            'startRecord',
            'stopRecord',
            'onVoiceRecordEnd',
            'playVoice',
            'onVoicePlayEnd',
            'pauseVoice',
            'stopVoice',
            'uploadVoice',
            'downloadVoice',
            'chooseImage',
            'previewImage',
            'uploadImage',
            'downloadImage',
            'getNetworkType',
            'openLocation',
            'getLocation',
            'hideOptionMenu',
            'showOptionMenu',
            'closeWindow',
            'scanQRCode',
            'chooseWXPay',
            'openProductSpecificView',
            'addCard',
            'chooseCard',
            'openCard'
          ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        });
        wx.ready(function () {
          wx.hideMenuItems({
            menuList: [
              'menuItem:copyUrl',
              'menuItem:openWithQQBrowse',
              'menuItem:openWithSafari',
              'menuItem:email',
              'menuItem:readMode',
              'menuItem:originPage',
              'menuItem:delete',
              'menuItem:editTag'
            ]
          });
        });

      }).catch(err =>
        console.log("获取微信授权失败" + err)
      )
    }
  },
  mounted: function () {
    this.getWxJs()
    const params = this.$route.query;
    const eno = params.eno;
    const c = params.c;
    const authCode = params.wyAuthCode

    const wechatAuth = sessionStorage.getItem("wechatAuth");
    const code = sessionStorage.getItem("queryCode");


    this.eno = eno
    if (authCode != "") {
      this.authCode = authCode
    }

    //此种情况代表的是从防伪码页面进来的，代表是多次扫码了
    if (c != null && eno != null && authCode != null) {
      this.antiCode = c.replace(/(\w{4})(?=\w)/g, '$1 ')
      this.showCheckCode = true
      return;
    }

    //这种情况代表是当前页面正常输入了防伪码之后，到输入验证码的页面了
    if (code != null && code != undefined) {
      const codes = code.split(",")
      this.antiCode = codes[0]
      this.checkCode = codes[1]
      this.showCheckCode = true
    }

    if (wechatAuth == "true" && this.antiCode != "" && this.checkCode != "" && eno != "") {
      window.location.href = "/quax/activity?q=" + this.antiCode + "&c=" + this.checkCode + "&eno=" + eno + "&authCode=" + authCode
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Quax/Scan.vue